module.exports = __webpack_public_path__ + "slovenia.svg?8ddb168be17c74c263927ebc8d162883";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/countries/svg/slovenia.svg
// module id = 295
// module chunks = 10